// LeadDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ENQUIRY_COMPANY_VIEW, ENQUIRY_LEAD_VIEW, GET_Lead_leadId } from '../../../services/apiRoutes';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import DetailPageCustum from '../../../components/common/DetailsPage/DetailPageCustum';

const EnquiryCompanyDetail = () => {
    const { clientCompanyId } = useParams();
    const [leadDetails, setLeadDetails] = useState(null);

    useEffect(() => {
        const authToken = sessionStorage.getItem('accessToken');

        axios.get(ENQUIRY_COMPANY_VIEW(clientCompanyId), {
            headers: {
                Authorization: `Bearer ${authToken}`,
            }
        })
            .then(response => {
                setLeadDetails(response.data.clientCompany);
            })
            .catch(error => {
                console.error('Error fetching lead details:', error);
            });
    }, [clientCompanyId]);

    if (!leadDetails) {
        return <p>Loading...</p>;
    }


    const tableData = [
        { label: 'Client Company', value: leadDetails.companyName || '' },
        { label: 'Email', value: leadDetails.email || '' },
        { label: 'Mobile', value: `+${leadDetails?.phonecode?.phonecode || ''}${leadDetails?.mobile || ''}` },
        { label: 'Address', value: `${leadDetails?.street || ''}, ${leadDetails.city?.name || ''}, ${leadDetails.state?.name || ''}, ${leadDetails.country?.name || ''}, ${leadDetails.zipCode || ''}.` },
    ];

    return <DetailPageCustum Icon={LeaderboardOutlinedIcon} title="Company Details" data={tableData} />;
};

export default EnquiryCompanyDetail;
